import { ExternalLink } from "lucide-react";
import TechnicalAnalysis from "./TechnicalAnalysis";
import StoryboardAnalysis from "./StoryboardAnalysis";
import SceneBreakdown from "./SceneBreakdown";
import GraphicsAnalysis from "./GraphicsAnalysis";
import VideoPlayerV3 from "@/components/ui/VideoPlayerV3";
import { useState } from "react";

const ResultsDisplay: React.FC<{
  thumbnail?: string;
  result: any;
  taskId?: string;
  onNewAnalysis: () => void;
  onClose: () => void;
  showBackToList?: boolean;
  onBackToList?: () => void;
  showNewAnalysis?: boolean;
}> = ({
  result,
  taskId,
  onNewAnalysis,
  onClose,
  showBackToList,
  onBackToList,
  showNewAnalysis = true,
  thumbnail,
}) => {
  const [currentlyPlaying, setCurrentlyPlaying] = useState<string | null>(null);

  return (
    <div className="p-4 space-y-6">
      {/* Header with integrated video */}
      <div className="flex items-start justify-between gap-6">
        <div className="flex-1">
          <h2 className="text-2xl font-medium text-gray-900 mb-2">
            Analysis Results
          </h2>
          <div className="w-48 mx-auto">
            <VideoPlayerV3
              thumbnailUrl={thumbnail}
              url={result.video_url}
              currentlyPlaying={currentlyPlaying}
              setCurrentlyPlaying={setCurrentlyPlaying}
              className="w-full aspect-[9/16] object-cover rounded-lg"
            />
          </div>
        </div>

        <div className="flex gap-4">
          {showNewAnalysis && (
            <button
              onClick={() => {
                onNewAnalysis();
                setTimeout(() => {
                  const uploadField = document.querySelector(".dropzone");
                  if (uploadField)
                    uploadField.scrollIntoView({ behavior: "smooth" });
                }, 100);
              }}
              className="text-sm text-gray-600 hover:text-gray-900"
            >
              New Analysis
            </button>
          )}

          {showBackToList && onBackToList ? (
            <button
              onClick={onBackToList}
              className="text-sm text-gray-600 hover:text-gray-900"
            >
              Back to List
            </button>
          ) : (
            <button
              onClick={onClose}
              className="text-sm text-gray-600 hover:text-gray-900"
            >
              Close
            </button>
          )}
        </div>
      </div>

      {/* Analysis Sections */}
      <div className="space-y-5">
        <StoryboardAnalysis data={result.storyboard_analysis} />
        <GraphicsAnalysis
          data={result.storyboard_analysis?.graphics_analysis}
        />
        <TechnicalAnalysis data={result.technical_analysis} />
        <SceneBreakdown scenes={result.storyboard_analysis?.scenes} />
      </div>
    </div>
  );
};

export default ResultsDisplay;
